module.exports = ".print-btn {\n  float: right; }\n\ntr.active-user td {\n  background: #dcedf9; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/today-order-list/today-order-list.component.scss
// module id = ./src/app/pages/today-order-list/today-order-list.component.scss
// module chunks = main